import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { Loader2, LockKeyhole } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("artpart_token", data.token);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Seo title="ArtPart Backend – Anmeldung" description="Geschützter Bereich." path="/admin/login" noindex />
      <main className="flex min-h-screen items-center justify-center bg-ink px-5">
        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="w-full max-w-sm border border-obsidian-line bg-obsidian p-7"
        >
          <p className="font-display text-2xl font-black uppercase tracking-[0.14em] text-paper">
            Art<span className="text-signal">Part</span>
          </p>
          <p className="ap-stamp mt-2 flex items-center gap-2">
            <LockKeyhole size={13} /> Backend-Anmeldung
          </p>

          <div className="mt-8 space-y-4">
            <div>
              <label className="ap-label" htmlFor="al-email">E-Mail</label>
              <input
                id="al-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email"
                className="w-full border border-obsidian-line bg-ink px-4 py-3 text-paper focus:border-signal focus:outline-none"
              />
            </div>
            <div>
              <label className="ap-label" htmlFor="al-pw">Passwort</label>
              <input
                id="al-pw"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
                className="w-full border border-obsidian-line bg-ink px-4 py-3 text-paper focus:border-signal focus:outline-none"
              />
            </div>
          </div>

          {error ? (
            <p role="alert" data-testid="admin-login-error" className="mt-5 border border-signal bg-signal/10 p-3 text-sm text-signal">
              {error}
            </p>
          ) : null}

          <button type="submit" disabled={busy} data-testid="admin-login-submit" className="ap-btn-invert mt-7 w-full disabled:opacity-60">
            {busy ? <Loader2 size={15} className="animate-spin" /> : null} Anmelden
          </button>
        </form>
      </main>
    </>
  );
}
